import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `deliveryNote.return.create${(param ? `.${param}` : '')}`, defaultValue);
